export default __webpack_public_path__ + "static/media/pcdStampIcon.8db407ad.svg";